import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApplicationData } from '../models/application-data.t';
import { CommonConfig } from '../constants/common-config';
import { environment } from 'src/environments/environment';
import { Option } from '../constants/option';
import { TokenStorageService } from './token-storage/token-storage.service';
import { ProfileService } from './profile/profile.service';
import { DownloadService } from './download/download.service';

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  lockScreen$ = new BehaviorSubject<boolean>(false);
  unlockScreen$ = new BehaviorSubject<boolean>(false);
  displayError$ = new BehaviorSubject<boolean>(false);
  errorMessage$ = new BehaviorSubject<string>('');
  data$ = new BehaviorSubject<ApplicationData>({
    tingkatPendidikans: [],
    hubungans: [],
    genders: [],
    golongans: [],
    jenisJabatans: [],
    jabatans: [],
    religions: [],
    jenisCutis: [],
    statusCutis: [],
    statusPegawais: [],
    substansis: [],
    jenisKenpas: [],
    jenisPenghargaans: [],
    penghargaans: [],
  });
  currentProfileId$ = new BehaviorSubject<string>('');
  currentProfileTab$ = new BehaviorSubject<number>(0);
  reload$ = new BehaviorSubject<boolean>(false);
  profilePicture = '';

  constructor(private http: HttpClient,
    private tokenStorageService: TokenStorageService,
    private profileService: ProfileService,
    private downloadService: DownloadService) { }

  init() {
    this.get().subscribe((res) => {
      const data = res;
      data.tingkatPendidikans = [Option.default, ...data.tingkatPendidikans];
      data.hubungans = [Option.default, ...data.hubungans];
      data.genders = [Option.default, ...data.genders];
      data.golongans = [Option.default, ...data.golongans];
      data.jenisJabatans = [Option.default, ...data.jenisJabatans];
      data.jabatans = [Option.default, ...data.jabatans];
      data.religions = [Option.default, ...data.religions];
      data.jenisCutis = [Option.default, ...data.jenisCutis];
      data.statusPegawais = [Option.default, ...data.statusPegawais];
      data.substansis = [Option.default, ...data.substansis];
      data.jenisKenpas = [Option.default, ...data.jenisKenpas];
      data.jenisPenghargaans = [Option.default, ...data.jenisPenghargaans];
      data.penghargaans = [Option.default, ...data.penghargaans];
      this.data$.next(data);
    });
    if (this.tokenStorageService.getToken()) {
      this.profileService.getUser(this.tokenStorageService.getId()).subscribe((res) => {
        this.tokenStorageService.saveUser(res);
        if (res.photo) {
          this.profilePicture = this.downloadService.downloadUrl(5, res.photo);
        } else {
          this.profilePicture = '/assets/images/users/' + (res.gender?.id === 1 ? 'male-pp.jpg' : 'female-pp.jpg');
        }
      });
    }
  }

  get(): Observable<ApplicationData> {
    return this.http.get<ApplicationData>(`${environment.apiUrl}/application-data/`,
      {
        ...CommonConfig.HTTP_OPTIONS,
      }
    );
  }
}
